/**
 * Creates a Slide up/down of Content
 * @module fixedOverlay
 */

import $ from 'jquery';

import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'fixedOverlay';
export const CLICK_EVENT = 'click';

export const DEFAULTS = {

};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} e - A jQuery event
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 */

// Activate SlideUp Event
const showOverlay = () => {
  const fixedOverlayScroll = $('.fixed-overlay__scroll');

  // Remove the ability to scroll main content while overlay is present
  $('body').css({ 'overflow-y': 'hidden' });

  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
  fixedOverlayScroll.addClass('fixed-overlay__scroll--active');
};

// Activate SlideDown Event
const closeOverlay = () => {
  const fixedOverlayScroll = $('.fixed-overlay__scroll');

  // Add back the ability to scroll main content when overlay is closed
  $('body').css({ 'overflow-y': 'auto' });

  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
};

/**
 * Applies any sort of event handlers for the fixedOverlay.
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

const applyEventHandlers = ($el, opts = {}) => {
  // .js-fixed-overlay
  $el.on(CLICK_EVENT, (evt) => {
    showOverlay(evt, $el, opts);
  });

  // .js-fixed-overlay-close
  $('.fixed-overlay__scroll').find('.js-fixed-overlay-close').on(CLICK_EVENT, () => {
    closeOverlay();
  });
};

/**
 * Initializes an fixedOverlay based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

// function fixedOverlay(el, options) {
export default function fixedOverlay(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);

  applyEventHandlers($el, opts);
}

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, fixedOverlay);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-overlay.js